module.exports = __webpack_public_path__ + "static/img/Lehi-Hopoate.4e0187f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lehi-Hopoate.jpg
// module id = HkaN
// module chunks = 0